import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .translatable()
    .sluggable()
    .hasTitle()
    .hasSummary()
    .hasImage()
    .hasBody()
    .hasMetadata()
    .publishable()
    .publishableByDate()
    .hasTimestamps()
    .make();

export default schema;
